var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"primary":"","small":""},on:{"click":_vm.open}},[_c('span',{staticClass:"truncate"},[_vm._v(" Edit ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }